import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SchemeOverviewView from "../../views/schemeOverview";
import { getSchemeOverviewDetails } from "../../redux/actions";
import { triggerShowHeader } from "../../redux/actions/action";
import { schemeCountDashboardNames } from "../../utils/constants";
import { getLastSixMonths } from "../../utils/common";
import { ExportToCsv } from "export-to-csv";

const SchemeOverview = () => {
  const dispatch = useDispatch();

  const { schemeOverview } = useSelector(
    (state) => state?.schemeOverviewReducer
  );

  const [searchFields, setSearchFields] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const downloadCSVData = () => {
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: `scheme-count-${new Date().getTime()}`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };
    let csvExporter = new ExportToCsv(options);

    schemeOverview?.data?.content?.length > 0 &&
      csvExporter.generateCsv(schemeOverview?.data?.content);
  };

  const onRunClick = () => {
    setPage(0);
    const schemeOverviewDTO = {
      headers: {
        url: "/get-scheme-details",
        "Content-Type": "application/json",
      },
      params: {
        moduleName: searchFields?.moduleName,
        startDate: JSON.parse(searchFields?.month)?.start,
        endDate: JSON.parse(searchFields?.month)?.end,
      },
    };
    dispatch(getSchemeOverviewDetails(schemeOverviewDTO));
  };

  useEffect(() => {
    dispatch(triggerShowHeader(false));

    setSearchFields({
      moduleName: schemeCountDashboardNames?.[0],
      month: getLastSixMonths()?.[0]?.value,
      schemeFilter: "",
    });
  }, [dispatch]);

  return (
    <SchemeOverviewView
      searchFields={searchFields}
      setSearchFields={setSearchFields}
      onRunClick={onRunClick}
      downloadCSVData={downloadCSVData}
      schemeOverview={schemeOverview}
      page={page}
      rowsPerPage={rowsPerPage}
      setPage={setPage}
      setRowsPerPage={setRowsPerPage}
    />
  );
};

export default SchemeOverview;
